import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ApiService } from 'src/app/Services/api.service';
import { SweetAlert } from 'src/app/Services/sweetalet.service';

@Component({
  selector: 'g10-sos-take-action',
  templateUrl: './sos-take-action.component.html',
  styleUrls: ['./sos-take-action.component.css']
})
export class SosTakeActionComponent implements OnInit {

  @Input() popup  = true;
  @Input() modalTitle  = 'SOS Action';
  @Input() sosID;
  @Output() closeEvent = new EventEmitter();
  @Output() result = new EventEmitter();

  
  public actionForm:FormGroup;
  public formSubmitted:boolean = false;
  
  constructor(
    private fb:FormBuilder,
    public swal: SweetAlert,
    public api: ApiService) { 

    }

  ngOnInit(): void {
    this.addActionForm();
  }

  addActionForm(){
    this.actionForm=this.fb.group({
      actionMessage:this.fb.control('',[Validators.required,Validators.pattern('^[a-zA-Z0-9_!@#$%^&*()., \']*$')]),
    });
  }
  submitForm(){
    this.formSubmitted = true;
    if (this.actionForm.valid){
      let obj = {
        sosID:this.sosID,
        ...this.actionForm.value,
        actionTime: new Date().getTime(),
      };
      console.log(obj);
      this.api.updateSosAlerts(obj).then((res: any) => {
        console.log(res.status);
        if (res.status == 'success') {
  
          this.swal.swalFunction(res.status, res.status, res.message, 2000);
          setTimeout(()=>{ 
            this.result.emit(true);
            this.closePopup();},3000);
        }
        if (res.status == 'failure') {
          this.swal.swalFunction('error', res.status, res.message, 3000);
        }
      }).catch((err) => {
        console.log(err);
      });
  
  }
}
  closePopup(){
    this.closeEvent.emit(true);
  }

}
